"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SrHeaderArea = require("./SrHeaderArea");

var _SrHeaderArea2 = _interopRequireDefault(_SrHeaderArea);

var _HeaderBottomLeft = require("./HeaderBottomLeft");

var _HeaderBottomLeft2 = _interopRequireDefault(_HeaderBottomLeft);

var _UserInfo = require("./UserInfo");

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Header = function Header(_ref) {
  var _ref$SrHeaderArea = _ref.SrHeaderArea,
      SrHeaderArea = _ref$SrHeaderArea === undefined ? _SrHeaderArea2.default : _ref$SrHeaderArea,
      _ref$HeaderBottomLeft = _ref.HeaderBottomLeft,
      HeaderBottomLeft = _ref$HeaderBottomLeft === undefined ? _HeaderBottomLeft2.default : _ref$HeaderBottomLeft,
      _ref$UserInfo = _ref.UserInfo,
      UserInfo = _ref$UserInfo === undefined ? _UserInfo2.default : _ref$UserInfo,
      props = _objectWithoutProperties(_ref, ["SrHeaderArea", "HeaderBottomLeft", "UserInfo"]);

  return _react2.default.createElement(
    "div",
    { id: "header", role: "banner" },
    _react2.default.createElement(
      "a",
      { href: "#content", id: "jumpToContent", tabIndex: 1 },
      "jump to content"
    ),
    (0, _util.optional)(SrHeaderArea, props),
    (0, _util.optional)(HeaderBottomLeft, props),
    (0, _util.optional)(UserInfo, props)
  );
};

exports.default = Header;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/Header.js
// module id = 313
// module chunks = 0